
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'

@Component
export default class extends Vue {
  onIndividualClick() {
    this.$router.push('/register/platform-individual')
  }

  onEnterpriseClick() {
    this.$router.push('/register/platform-enterprise')
  }

  mounted() {
    UserModule.LogOut()
  }
}
